import React from "react";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import {AuthorizedContext, AuthorizedContextProvider} from "../context/AuthorizedContext";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import CommonShipmentsComponents from "../components/core/shipments/CommonShipmentsComponents";
import {EVENT_UPDATE_PAGE_PATH, HOME_OVERVIEW_PAGE_PATH} from "../layouts/navigation/Navigator";
import {Update} from "@material-ui/icons";
import queryString from 'query-string';
import {Navigate, useLocation} from "react-router-dom";
import {SHIPMENT_PERMISSIONS} from "../constants/ShipmentPermissionsConstants";
import { normalizeToNumber, normalizeToString } from "../utils/QueryParamNormalizerUtils";

const EventUpdateNotAllowedRedirect = () => {
    const {hasPermission} = React.useContext(AuthorizedContext);

    if (!hasPermission(SHIPMENT_PERMISSIONS.MILESTONE_LIST)) {
        return <Navigate to={HOME_OVERVIEW_PAGE_PATH}/>
    }
    return null;
};

function EventUpdatePage() {


    const {t} = useTranslation();

    const {search} = useLocation();
    const {load, query, scroll} = queryString.parse(search);

    const [initLoad, setInitLoad] = React.useState(0);
    const [initQuery, setInitQuery] = React.useState('');
    const [initScroll, setInitScroll] = React.useState(0);

    React.useEffect(() => {
        setInitLoad(normalizeToNumber(load));
        setInitQuery(normalizeToString(query));
        setInitScroll(normalizeToNumber(scroll));
    }, [load, query, scroll]);


    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.event-update")}</title>
                <meta name="description" content={t("page.title.event-update")}/>
            </Helmet>

            <AuthenticatedUserLayout pageTitle={t("page.title.event-update")}>
                <EventUpdateNotAllowedRedirect/>
                <CommonShipmentsComponents detailsPagePath={EVENT_UPDATE_PAGE_PATH} Icon={<Update/>} initLoad={initLoad}
                                           initQuery={initQuery} initScroll={initScroll}/>
            </AuthenticatedUserLayout>
        </AuthorizedContextProvider>
    );


}

export default EventUpdatePage;
